var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66559 0.6875H2.43402C1.11725 0.6875 0.0498047 1.75495 0.0498047 3.07171V10.3033C0.0498047 11.6201 1.11725 12.6875 2.43402 12.6875H9.66559C10.9824 12.6875 12.0498 11.6201 12.0498 10.3033V3.07171C12.0498 1.75495 10.9824 0.6875 9.66559 0.6875Z",
    fill: "#121622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7235 6.44117C10.3319 5.44854 8.73925 4.17275 8.28872 3.93275L7.93609 3.74538L7.74557 4.09275C7.51083 4.52117 7.28136 4.9338 7.05083 5.32643C6.91399 5.16749 6.76662 5.01696 6.61083 4.87591L6.60662 4.87275C4.89715 3.36012 3.27188 3.53275 2.32136 4.19907C1.38978 4.8517 1.00662 5.98854 1.39083 6.96328C1.79925 7.99696 3.48346 9.38433 3.77715 9.59591L3.98767 9.74854L4.21293 9.61907C6.02872 8.57907 7.1003 6.92222 8.24241 4.86222C8.80241 5.28328 9.74662 6.14328 9.9803 6.73591C10.2056 7.31275 9.91083 8.06644 9.27399 8.52749C8.94767 8.76328 7.78767 9.42959 6.30767 8.2738C6.12136 8.46959 5.92451 8.65591 5.71925 8.8317C7.2782 10.1054 8.8203 9.84644 9.74451 9.17801C10.6877 8.49486 11.0919 7.3717 10.7256 6.44222L10.7235 6.44117ZM4.03925 8.78433C3.48767 8.3338 2.38767 7.30749 2.13609 6.66854C1.88872 6.04117 2.15399 5.29486 2.7803 4.85591C3.1203 4.62538 3.52241 4.50328 3.93399 4.50749C4.4982 4.50749 5.22767 4.72433 6.07188 5.46959C6.26872 5.64643 6.44662 5.84433 6.60136 6.05801C5.87399 7.19065 5.08872 8.12117 4.03925 8.78328V8.78433Z",
    fill: "url(#paint0_linear_7236_1860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7236_1860",
    x1: 11.9782,
    y1: 10.4528,
    x2: 1.04662,
    y2: 3.68749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ADDFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon_logo.4f0aa3f54d0df2bed42f30b07dc177c0.svg";
export { ForwardRef as ReactComponent };